import React from 'react';
import oIcon from '../assets/o.svg';
import '../styles/attributes.css';

function O() {
  return <img className="letter" src={oIcon} alt="x-letter" />;
}

export default O;
